import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
type CollectionNoDataStateProps = {
  collectionId?: string;
  isCollectionError: boolean;
  isAllDataLoaded: boolean;
  hasCollection: boolean;
  isLoading?: boolean;
};

export const CollectionNoDataState = ({
  collectionId,
  isCollectionError,
  isAllDataLoaded,
  hasCollection,
  isLoading = false,
}: CollectionNoDataStateProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '25vh',
        width: '100%',
        color: 'text.secondary',
        gap: 2,
        mt: 2,
      }}
    >
      {isLoading ? (
        <>
          <CircularProgress size={48} />
          <Typography variant='h6'>
            {t('Loading collection data...')}
          </Typography>
        </>
      ) : collectionId && isCollectionError ? (
        <>
          <ErrorOutlineIcon color='error' sx={{ fontSize: 48 }} />
          <Typography variant='h6' color='error'>
            {t('Error loading collection data')}
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            {t('Collection ID "{{id}}" was not found or could not be loaded.', {
              id: collectionId,
            })}
          </Typography>
        </>
      ) : collectionId && isAllDataLoaded && !hasCollection ? (
        <>
          <ErrorOutlineIcon color='warning' sx={{ fontSize: 48 }} />
          <Typography variant='h6'>{t('Collection not found')}</Typography>
          <Typography variant='body2'>
            {t('No collection found with ID "{{id}}".', { id: collectionId })}
          </Typography>
        </>
      ) : collectionId ? (
        <>
          <Typography variant='h6'>
            {t('Loading collection data...')}
          </Typography>
        </>
      ) : (
        <>
          <Typography variant='h6'>
            {t('Select a collection or search by collection ID.')}
          </Typography>
        </>
      )}
    </Box>
  );
};
